import Cookies from 'universal-cookie'
import { ROUTE } from '../constants/routingConfig/routeDetails'
import { cartItem } from '../../../redux-saga/User/Login/Reducer'

export const handleBuy = (pesticide, history) => {
  if (!JSON.parse(localStorage.getItem('user'))) history.push(ROUTE.LOGIN)
  else {
    if (typeof (pesticide) === 'object') {
      const pesticideArray = []
      pesticideArray.push(pesticide)
      localStorage.removeItem('orderList')
      localStorage.setItem('orderList', JSON.stringify(pesticideArray))
    } else {
      localStorage.removeItem('orderList')
      localStorage.setItem('orderList', JSON.stringify(pesticide))
    }
    history.push(ROUTE.ORDER)
  }
}

export const handleBuyAll = (pesticide, type, history) => {
  if (!JSON.parse(localStorage.getItem('user'))) history.push(ROUTE.LOGIN)
  else {
    if (type === 'object') {
      const pesticideArray = []
      pesticideArray.push(pesticide)
      localStorage.removeItem('orderList')
      localStorage.setItem('orderList', JSON.stringify(pesticideArray))
    } else {
      localStorage.removeItem('orderList')
      localStorage.setItem('orderList', JSON.stringify(pesticide))
    }
    history.push(ROUTE.ORDER)
  }
}

export const handleAddToCart = (e, id, history, dispatch) => {
  e.preventDefault()
  const cookies = new Cookies()
  const prevId = cookies.get('cart')
  let idArray = prevId && prevId.split('#')
  if (idArray?.length && idArray.includes(id.toString())) history.push(ROUTE.CART)
  let currentId = ''
  if (prevId && idArray?.length && !idArray.includes(id.toString())) {
    currentId = `${ id }#${ prevId }`
  } else if (!prevId) {
    currentId = `${ id }`
  } else {
    currentId = `${ prevId }`
  }
  idArray = currentId.split('#')
  dispatch(cartItem(idArray?.length))
  cookies.set('cart', currentId, { path: ROUTE.HOME, Expires: 1000 * 60 * 24 * 365 })
}

export const isAddedInCart = (pesticide) => {
  const cookies = new Cookies()
  const prevId = cookies.get('cart')
  const idArray = prevId && prevId.split('#')
  return idArray?.length && idArray.includes(pesticide.id.toString())
}
